import React from "react";
import RevealAnimation from "../RevealAnimation";
import "./whyVC2Section.scss";
import {
  FiUsers,
  FiCpu,
  FiZap,
  FiShield,
  FiTrendingUp,
  FiSettings,
  FiAlertCircle,
  FiCheckCircle,
  FiTarget,
} from "react-icons/fi";

const WhyVC2Section = () => {
  const founderProblems = [
    { icon: <FiUsers />, label: "Hiring" },
    { icon: <FiCpu />, label: "Architecture" },
    { icon: <FiZap />, label: "Execution" },
    { icon: <FiTarget />, label: "Product strategy" },
    { icon: <FiSettings />, label: "Technical decisions" },
    { icon: <FiTrendingUp />, label: "Delivery management" },
  ];

  const vc1Causes = [
    "12 - 18 months delay in forming the right team",
    "Wrong hires and inconsistent delivery",
    "MVPs that fail to gain traction",
    "Technical debt that must be rebuilt later",
    "High founder stress and investor uncertainty",
  ];

  return (
    <section className="why-vc2-section" id="why-vc2">
      <div className="body-container">
        <RevealAnimation>
          <div className="section-header">
            <h2>Why the World Needed VC 2.0</h2>
          </div>
        </RevealAnimation>

        <div className="content-layout">
          {/* First Card - VC 1.0 Problem */}
          <RevealAnimation delay={0.1}>
            <div className="bento-card hero-card">
              <div className="card-header">
                <div className="icon-badge alert">
                  <FiAlertCircle />
                </div>
                <h3>Traditional VC (VC 1.0) only provides capital.</h3>
              </div>
              <p className="card-subtitle">Founders are left to figure out:</p>
              <div className="problems-grid">
                {founderProblems.map((problem, index) => (
                  <div key={index} className="problem-chip">
                    <span className="chip-icon">{problem.icon}</span>
                    <span className="chip-label">{problem.label}</span>
                  </div>
                ))}
              </div>
              <div className="stat-highlight">
                <div className="stat-number">90%</div>
                <div className="stat-text">
                  of VC-backed startups fail-not because they lack capital, but
                  because they lack <strong>execution support.</strong>
                </div>
              </div>
              <div className="impact-statement">
                This creates{" "}
                <strong>
                  slow builds, high burn, weak products, and unnecessary risk.
                </strong>
              </div>
            </div>
          </RevealAnimation>

          <div>
            {/* Second Card - VC 1.0 Causes */}
            <RevealAnimation delay={0.2}>
              <div className="bento-card causes-card">
                <h4 className="causes-title">Why does VC 1.0 fall short?</h4>
                <p className="causes-subtitle">VC 1.0 causes:</p>
                <ul className="causes-list">
                  {vc1Causes.map((cause, index) => (
                    <li key={index}>{cause}</li>
                  ))}
                </ul>
              </div>
            </RevealAnimation>
            {/* Third Card - Solution */}
            <RevealAnimation delay={0.3}>
              <div className="bento-card solution-card">
                <div className="solution-content">
                  <div className="solution-header">
                    <div className="solution-icon">
                      <FiTarget />
                    </div>
                    <h3>ventureRyte changes everything.</h3>
                  </div>
                  <div className="solution-body">
                    <div className="feature-badge">
                      <FiCheckCircle />
                      <span>Capital + Execution Infrastructure</span>
                    </div>
                    <p className="solution-description">
                      <strong>ventureRyte</strong> = Technology Capital +
                      Strategy + Team + Execution + MMP-first build model.
                    </p>
                    <p className="solution-cta">
                      We don't just fund startups.{" "}
                      <strong>We build them with you.</strong>
                    </p>
                    <p className="solution-footer">
                      Founders get <strong>capability</strong>, not chaos.
                    </p>
                  </div>
                </div>
              </div>
            </RevealAnimation>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyVC2Section;
